const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error'
};

// Timezone offset mappings (hours from UTC) — English + French Canadian
const TIMEZONE_OFFSETS = {
  // English
  EST: -5, EDT: -4,
  CST: -6, CDT: -5,
  MST: -7, MDT: -6,
  PST: -8, PDT: -7,
  AST: -4, ADT: -3,
  NST: -3.5, NDT: -2.5,
  // French (Canadian)
  HNE: -5, HAE: -4,
  HNC: -6, HAC: -5,
  HNR: -7, HAR: -6,
  HNP: -8, HAP: -7,
  HNA: -4, HAA: -3,
  HNT: -3.5, HAT: -2.5
};
